export default __webpack_public_path__ + "static/media/990.b19412cd.gif";